import type { Account } from '../../api/monitor';
import { accountSubtitle, accountTitle, linesLabel, operatorShort } from '../../lib/accounts';
import { operatorPill } from '../../lib/operators';

/** Uma conta de portal: login, dono, quantas linhas tem, se está ativa e o editar. */
export function AccountRow({ account, onEdit }: { account: Account; onEdit: (account: Account) => void }) {
  return (
    <div className="border-surface-200 flex items-center gap-2.5 border-b px-4 py-3 last:border-b-0">
      <div
        className={`flex size-9 shrink-0 items-center justify-center rounded-[10px] text-[12px] font-extrabold ${operatorPill(account.operator.code)}`}
        title={account.operator.name}
      >
        {operatorShort(account.operator)}
      </div>

      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-extrabold">{accountTitle(account)}</div>
        <div className="text-ink-600 mt-px truncate text-[11.5px]">
          {accountSubtitle(account)}
        </div>
      </div>

      <div className="shrink-0 text-right">
        <div className="text-[12.5px] font-bold">{linesLabel(account.lines)}</div>
        <div
          className={`mt-0.5 inline-block rounded-full px-2 py-0.5 text-[10.5px] font-bold ${
            account.active ? 'bg-ok-100 text-ok-600' : 'bg-danger-100 text-danger-600'
          }`}
        >
          {account.active ? 'Ativa' : 'Inativa'}
        </div>
      </div>

      <button
        type="button"
        onClick={() => onEdit(account)}
        className="border-line-300 text-navy-800 hover:border-navy-800 hover:bg-surface-100 shrink-0 rounded-lg border bg-white px-3 py-1.5 text-[12px] font-bold"
      >
        Editar
        <span className="sr-only"> a conta {accountTitle(account)}</span>
      </button>
    </div>
  );
}
